import classNames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import checkmark from '_images/checkmark.svg';
import getQuoteBg from '_images/get-quote-bg.png';

export default function GetQuoteCard({ className, utmMedium }) {
  return (
    <div
      className={classNames(
        'w-[300px] h-[250px] p-6 bg-os-light-blue-25 rounded-lg mt-8 relative',
        className,
      )}
    >
      <div className="absolute inset-0">
        <img
          src={getQuoteBg}
          alt="get quote bg"
          className="w-full h-full object-cover z-10"
        />
      </div>
      <div className="font-bold text-xl leading-6">
        Sell your car at the highest price in Singapore
      </div>
      <ul className="mt-3.5 mb-0 flex flex-col gap-y-2">
        {[
          'Convenient and Hassle-Free',
          'Consumer Protection',
          <p className="m-0 leading-4.5">
            Transparent Process <br /> With No Obligation
          </p>,
        ].map((item, index) => (
          <li key={index} className="flex gap-x-2.5">
            <div className="mt-[1px] w-4 h-4">
              <img src={checkmark} alt="pros" className="w-4 h-4" />
            </div>
            <div className="flex-1 text-sm leading-4.5">{item}</div>
          </li>
        ))}
      </ul>
      <div className="mt-4 relative z-20">
        <Link
          to={`/sell-my-car-online-to-dealer-singapore/?utm_source=os-intads&utm_medium=${utmMedium}&utm_campaign=square-s2c`}
          className="bg-caroured50 text-white hover:text-white font-bold py-1 px-4 rounded text-base inline-block text-center"
        >
          Get Quote
        </Link>
      </div>
    </div>
  );
}
